import { FC } from "react";
import ArrowSvg from "@/public/icon/arrow";
import { cn } from "@/lib/utils";

interface ArrowIconProps {
  leftClass?: string;
  rightClass?: string;
  className?: string;
}

export const ArrowIcon: FC<ArrowIconProps> = ({
  leftClass = "w-64 h-1.5 from-[#79D880] to-[#43B049]",
  rightClass = "w-8 h-9 text-[#004EA2]",
  className,
}) => {
  return (
    <div className={cn("flex items-center", className)}>
      <i className={cn("inline-block bg-gradient-to-r", leftClass)}></i>
      <ArrowSvg className={cn("ml-[-0.5rem]", rightClass)} />
    </div>
  );
};
